import { useTheme } from '@emotion/react';
import React, { useCallback } from 'react';

import { Alert, Box, Button, Drawer, Grid, Header } from '~/components/blocks';
import { GuestPatientForm } from '~/components/partials/GuestPatientForm';

import { InputForm } from '../InputForm';
import { useDefaultValues } from './use-default_values';
import { useSubmitNewPatient } from './use-submit-new-patient';

export const InputNewPatientPanel = () => {
  const theme = useTheme();

  const defaultValues = useDefaultValues();
  const { isSubmitting, error, containerRef, formRef, handleSubmit } = useSubmitNewPatient();

  const handleSend = useCallback(() => {
    formRef.current?.submitForm();
  }, [formRef]);

  return (
    <Grid height="100%" gridTemplateRows="min-content 1fr min-content" overflow="auto">
      <Header attached="drawer">患者登録</Header>
      <Box ref={containerRef} overflow="auto" paddingX={theme.space.l}>
        {error && (
          <Alert status="error" marginTop={theme.space.l} whiteSpace="pre-wrap">
            {error}
          </Alert>
        )}
        <InputForm marginTop={theme.space.l}>
          <GuestPatientForm
            ref={formRef}
            disabled={isSubmitting}
            initialValues={defaultValues}
            onSubmit={handleSubmit}
          />
        </InputForm>
      </Box>
      <Drawer.Footer>
        <Button use="base" wide="fill" size="l" loading={isSubmitting} onClick={handleSend}>
          登録
        </Button>
      </Drawer.Footer>
    </Grid>
  );
};
